var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3 20.6909L21.2 13.861C21.13 13.6515 21.0142 13.4601 20.861 13.301C21.2737 12.8239 21.5017 12.2147 21.504 11.584V2.91797C21.5034 2.20978 21.2215 1.53082 20.7201 1.03058C20.2188 0.530396 19.5392 0.249939 18.831 0.250977H5.164C3.6929 0.254272 2.50165 1.4469 2.5 2.91797V11.584C2.50201 12.2141 2.72937 12.8229 3.14099 13.2999C2.98776 13.4591 2.87195 13.6504 2.802 13.86L0.727997 20.615C0.392181 21.2866 0.428101 22.0844 0.822876 22.7231C1.21765 23.3619 1.91504 23.7509 2.66599 23.751H21.328C22.08 23.7539 22.7791 23.3641 23.172 22.723C23.5621 22.113 23.6105 21.3451 23.3 20.6909ZM15.507 21.1481C15.4142 21.277 15.2658 21.3541 15.107 21.3561H8.89999C8.73935 21.356 8.58856 21.2786 8.49466 21.1483C8.40079 21.0179 8.37521 20.8505 8.42599 20.698L9.02597 18.8981C9.09396 18.694 9.28485 18.5562 9.49997 18.556H14.5C14.7155 18.5558 14.9069 18.6936 14.975 18.8981L15.575 20.698C15.6239 20.8513 15.5959 21.0188 15.5 21.1481H15.507ZM5.16699 2.25098C4.79861 2.25098 4.49997 2.54962 4.49997 2.91797L4.49698 11.584C4.49698 11.9524 4.79559 12.251 5.16397 12.251H18.831C19.199 12.2504 19.497 11.9519 19.497 11.584V2.91797C19.497 2.54999 19.199 2.25153 18.831 2.25098H5.16699Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.bfb43949.svg";
export { ForwardRef as ReactComponent };